<template>
  <div>
    <fieldset :key="name" v-show="!(field.hide && field.hide())">
      <legend v-if="field.label">
        <h5 class="jsonLabel" :id="field.id ? field.id : ''">{{ field.label }}</h5>
      </legend>

      <div>
        <template v-for="(aField, aName) in field.fields">
          <md-field :key="aName + '_input'" :class="[
                  { 'md-valid': $vo[name] && $vo[name].fields[aName] && Object.keys($vo[name].fields[aName].$params).length && !$vo[name].fields[aName].$invalid },
                  { 'md-error': $vo[name] && $vo[name].fields[aName] && Object.keys($vo[name].fields[aName].$params).length && $vo[name].fields[aName].$invalid },
                  { '_uiKitInput': isUiKit },
                ]">
            <label>{{ aField.label }}</label>
            <md-input
              v-if="aField.type != 'select'"
              :name="aName"
              v-model.trim="$vo[name].fields[aName].$model"
              :disabled="pageMode == 'view' || pageMode == 'assignee' || aField.preventEdit"
            ></md-input>

            <!-- ATLAS-848 Make "State" a drop down and not an open field -->
            <select
              v-if="aField.type == 'select'"
              class="md-list-item-button md-list-item-container md-button-clean"
              style="padding: 7px;font-size: 14px; color: #13294d !important;"
              :key="aName"
              :name="aName"
              v-model="$vo[name].fields[aName].$model"
              :disabled="pageMode == 'view' || pageMode == 'assignee' || aField.preventEdit"
            >
              <option v-for="item in aField.options" :value="item.id" :key="item.id"> {{ item.name }} </option>
            </select>

            <md-icon v-if="$vo[name] && $vo[name].fields[aName] && Object.keys($vo[name].fields[aName].$params).length && $vo[name].fields[aName].$invalid">clear</md-icon>
            <md-icon v-else-if="$vo[name] && $vo[name].fields[aName] && Object.keys($vo[name].fields[aName].$params).length && !$vo[name].fields[aName].$invalid">done</md-icon>
          </md-field>
        </template>
      </div>
    </fieldset>
  </div>
</template>

<script>
  export default {
    name: "crud-json",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      isUiKit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {}
    },
  };
</script>